import React from 'react';
import PropTypes from 'prop-types';

class Above extends React.Component {
  static defaultProps = {
    color: '#fff',
    width: '20px',
    height: '20px',
  };

  render() {
    return (
      <svg
        version="1.1"
        width={this.props.width}
        height={this.props.height}
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 10.1 6.2"
      >
        <path
          fill={this.props.color}
          d="M10.1,5.4c0,0.2-0.1,0.4-0.2,0.6C9.6,6.3,9.1,6.3,8.8,6L5.1,2.3L1.4,6C1.1,6.3,0.5,6.3,0.2,6s-0.3-0.8,0-1.1L5.1,0l4.8,4.8C10,5,10.1,5.2,10.1,5.4z"
        />
      </svg>
    );
  }
}

Above.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
};

export default Above;
